/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Tab_DocumentsInputs */

const cs_property_tab_documents = /** @type {(inputs: Property_Tab_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumenty`)
};

const en_property_tab_documents = /** @type {(inputs: Property_Tab_DocumentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents`)
};

/**
* | output |
* | --- |
* | "Documents" |
*
* @param {Property_Tab_DocumentsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_tab_documents = /** @type {((inputs?: Property_Tab_DocumentsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Tab_DocumentsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_tab_documents(inputs)
	return cs_property_tab_documents(inputs)
});